export const cities = [
  {
    id: '1',
    city: 'Swat'
  },
  {
    id: '2',
    city: 'Malakand'
  },
  {
    id: '3',
    city: 'Upper Dir'
  },
  {
    id: '4',
    city: 'Lower Dir'
  },
  {
    id: '5',
    city: 'Buner'
  },
  {
    id: '6',
    city: 'Shangla'
  },
  {
    id: '7',
    city: 'Chitral Upper'
  },
  {
    id: '8',
    city: 'Chitral Lower'
  },
  {
    id: '9',
    city: 'Bajaur'
  },
  {
    id: '10',
    city: 'Mohmand'
  },
  {
    id: '11',
    city: 'Khyber'
  },
  {
    id: '12',
    city: 'Orakzai'
  },
  {
    id: '13',
    city: 'Kurram'
  },
  {
    id: '14',
    city: 'North Waziristan'
  },
  {
    id: '15',
    city: 'South Waziristan'
  },

  // Gilgit-Baltistan Districts
  {
    id: '16',
    city: 'Gilgit'
  },
  {
    id: '17',
    city: 'Hunza'
  },
  {
    id: '18',
    city: 'Nagar'
  },
  {
    id: '19',
    city: 'Ghizer'
  },
  {
    id: '20',
    city: 'Diamer'
  },
  {
    id: '21',
    city: 'Astore'
  },
  {
    id: '22',
    city: 'Shigar'
  },
  {
    id: '23',
    city: 'Skardu'
  },
  {
    id: '24',
    city: 'Kharmang'
  },
  {
    id: '25',
    city: 'Ghanche'
  },

  // Balochistan border regions commonly associated with NCP vehicles
  {
    id: '26',
    city: 'Chaman'
  },
  {
    id: '27',
    city: 'Qila Abdullah'
  },
  {
    id: '28',
    city: 'Nushki'
  },
  {
    id: '29',
    city: 'Kharan'
  },
  {
    id: '30',
    city: 'Washuk'
  },
  {
    id: '31',
    city: 'Panjgur'
  },
  {
    id: '32',
    city: 'Turbat'
  },
  {
    id: '33',
    city: 'Gwadar'
  }
];